module.exports = __webpack_public_path__ + "media/images/icon__checkmark--white@2x-d76524379bbe7428a823de9e1b1b40cf.png";